import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './shared/components/layout/Layout';
import GlobalProgressBar from './shared/components/GlobalProgressBar';
import {
  AuthProvider,
  ProtectedRoute,
  RequireProjectAccess,
  CalibrationsRoute,
  AdminRoute,
  LoginPage,
  UnauthorizedPage,
} from './features/auth';
import { Dashboard } from './features/dashboard';
import CalibrationManagement from './features/calibration/pages/CalibrationManagement';
import CalibrationDetailsPage from './features/calibration/pages/CalibrationDetailsPage';
import StartCalibrationPage from './features/calibration/pages/StartCalibrationPage';
import BulkCalibrationPage from './features/calibration/pages/BulkCalibrationPage';
// import StartCalibrationPage from './features/calibration/schemaDriven/SingleCalibrationPage';
// import BulkCalibrationPage from './features/calibration/schemaDriven/BulkCalibrationPage';
import ManageAcceptanceCriteria from './features/manage/pages/ManageAcceptanceCriteria';
import ManageDailyEnvironmentalData from './features/manage/pages/ManageDailyEnvironmentalData';
import { ModalProvider } from './shared/components/providers/ModalContext';
import NotFound from './shared/components/NotFound';
import { FormBuilderListPage, FormBuilderEditorPage, FormRuntimePage, FormAuditLogPage, FormVersionHistoryPage, DynamicFieldsListPage, DynamicFieldsEditorPage, DynamicFieldsVersionsPage, DynamicFieldsAuditPage } from './features/formBuilder';
import { ROUTES, ROUTE_PATTERNS } from './config/links';

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <Router>
          <div className="App">
            <GlobalProgressBar />
            <Routes>
              <Route path={ROUTE_PATTERNS.LOGIN} element={<LoginPage />} />
              <Route path={ROUTE_PATTERNS.UNAUTHORIZED} element={<UnauthorizedPage />} />
              <Route
                path={ROUTE_PATTERNS.ROOT}
                element={
                  <ProtectedRoute>
                    <RequireProjectAccess>
                      <Layout />
                    </RequireProjectAccess>
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route
                  path={ROUTE_PATTERNS.CALIBRATIONS}
                  element={
                    <CalibrationsRoute>
                      <CalibrationManagement />
                    </CalibrationsRoute>
                  }
                />
                <Route
                  path={ROUTE_PATTERNS.CALIBRATIONS_START}
                  element={
                    <CalibrationsRoute>
                      <StartCalibrationPage />
                    </CalibrationsRoute>
                  }
                />
                <Route
                  path={ROUTE_PATTERNS.CALIBRATIONS_BULK_START}
                  element={
                    <CalibrationsRoute>
                      <BulkCalibrationPage />
                    </CalibrationsRoute>
                  }
                />
                <Route
                  path={ROUTE_PATTERNS.CALIBRATIONS_DETAILS}
                  element={
                    <CalibrationsRoute>
                      <CalibrationDetailsPage />
                    </CalibrationsRoute>
                  }
                />
                <Route path={ROUTE_PATTERNS.FORM_BUILDER} element={<AdminRoute><FormBuilderListPage /></AdminRoute>} />
                <Route path={ROUTE_PATTERNS.FORM_BUILDER_NEW} element={<AdminRoute><FormBuilderEditorPage /></AdminRoute>} />
                <Route path={ROUTE_PATTERNS.FORM_BUILDER_AUDIT} element={<AdminRoute><FormAuditLogPage /></AdminRoute>} />
                <Route path={ROUTE_PATTERNS.FORM_BUILDER_VERSIONS} element={<AdminRoute><FormVersionHistoryPage /></AdminRoute>} />
                <Route path={ROUTE_PATTERNS.FORM_BUILDER_EDIT} element={<AdminRoute><FormBuilderEditorPage /></AdminRoute>} />
                <Route path={ROUTE_PATTERNS.DYNAMIC_FIELDS} element={<AdminRoute><DynamicFieldsListPage /></AdminRoute>} />
                <Route path={ROUTE_PATTERNS.DYNAMIC_FIELDS_EDIT} element={<AdminRoute><DynamicFieldsEditorPage /></AdminRoute>} />
                <Route path={ROUTE_PATTERNS.DYNAMIC_FIELDS_VERSIONS} element={<AdminRoute><DynamicFieldsVersionsPage /></AdminRoute>} />
                <Route path={ROUTE_PATTERNS.DYNAMIC_FIELDS_AUDIT} element={<AdminRoute><DynamicFieldsAuditPage /></AdminRoute>} />
                {/* The published-forms list now lives in the form builder (Live filter). */}
                <Route path={ROUTE_PATTERNS.FORMS} element={<Navigate to={ROUTES.FORM_BUILDER_LIVE} replace />} />
                <Route path={ROUTE_PATTERNS.FORM_RUNTIME} element={<FormRuntimePage />} />
                <Route
                  path={ROUTE_PATTERNS.MANAGE_ACCEPTANCE_CRITERIA}
                  element={
                    <AdminRoute>
                      <ManageAcceptanceCriteria />
                    </AdminRoute>
                  }
                />
                <Route
                  path={ROUTE_PATTERNS.MANAGE_DAILY_ENV_DATA}
                  element={
                    <AdminRoute>
                      <ManageDailyEnvironmentalData />
                    </AdminRoute>
                  }
                />
                <Route path={ROUTE_PATTERNS.NOT_FOUND} element={<NotFound />} />
              </Route>
            </Routes>
            <Toaster
              position="top-right"
              containerStyle={{ zIndex: 99999 }}
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
              }}
            />
          </div>
        </Router>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;
